import { createFromIconfontCN } from "@ant-design/icons";

export const VitriaIcon = createFromIconfontCN({
  scriptUrl: "/icons/icons.js",
});